<template>
    <section id="home-slide-home" class="py-5 text-center container-fluid">
        <div class="row py-lg-5 items-center px-5">
            <div class="col-md-6 ps-5 pe-5">
                <div class="flex justify-around">
                    <img src="/static/img/FRENCHIOT_2023.png" style="height: 140px; width: 140px;" />
                </div>
                <h1 class="p-4">{{ gettext("Octolo Habitat : vos assemblées générales, conseils et comités en quelques clics") }}</h1>
                <button id="login-button" type="button" class="btn btn-primary shrink-2 m-[15px]" @click="goToContact('habitat')">
                    <span class="pe-1 text-3xl">{{ gettext("Demander une démo") }}</span>
                </button>
            </div>
            <div class="col-md-6 mt-4 test">
                <button class="btn-logo dataroom shrink-5"
                    @click="goToContact('meetings')">
                    AG & Board
                </button>
                <button class="btn-logo meetings shrink-5"
                    @click="goToContact('dataroom')">
                    Dataroom
                </button>
                <button class="btn-logo tkpi shrink-5"
                    @click="goToContact('tkpi')">
                    Table de Capitalisation
                </button>
                <div class="octopus-container">
                    <div class="circle"/>

                    <svg class="poulpe" id="eMILvNZwRf21" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 420.31 534.61"
                        shape-rendering="geometricPrecision" text-rendering="geometricPrecision">
                        <g id="eMILvNZwRf22" transform="translate(0 20)">
                            <g>
                                <path d="" fill="#68dfa3" />
                                <path d="" fill="#68dfa3" />
                                <path
                                    d="M221.448441,262.362052c-.167534-.183629-.333689-.367648-.498441-.552052C272.3,248.75,353.2,206.1,353.2,116.3c0-35.86-13.49-67.66-37-87.26-19.99-16.66-45.56-23.16-72.01-18.32-58.39,10.7-105.88,74.29-105.88,141.76.000401,34.661645-2.086264,86.64398-3.099886,129.55"
                                    fill="#68dfa3" />
                                <path d="" fill="#e84242" />
                                <circle r="44.31" transform="translate(218.05 163.42)" fill="#fff" />
                                <circle r="8.86" transform="translate(218.05 163.42)" fill="#283583" />
                            </g>
                            <ellipse id="eMILvNZwRf210" rx="47.951754" ry="49.665198"
                                transform="matrix(1.182548 0 0 0.447925 218.05 96.863716)" fill="#68dfa3"
                                stroke-width="0" />
                        </g>
                        <g id="eMILvNZwRf211" transform="translate(0 20)">
                            <path
                                d="M223.851487,258.651883l-35.312086-.320287l7.773213,20.586621c.32-.24,19.437386,20.951783,19.737386,20.691783c25.97,19.41,52.64,27.18,76.4,29.13c29.87,2.45,63.52-20.06,67.79-48.06.57-3.74.67-7.48.31-11.15-.77-7.89-3.66-15.46-8.48-22.02-7.06-9.6-17.45-15.88-29.23-17.67-9.54-1.45-19.07.89-26.84,6.61s-12.85,14.12-14.3,23.65c-2.3,15.05,5.66,27.31,20.71,29.6c10.4,1.58,22.56-3.75,24.15-14.15.88-5.76-23.58,11.22-23.98-12.27-.07-4,2.71-7.45,5.94-9.82c3.22-2.37,7.18-3.35,11.14-2.74c6.21.95,11.67,4.25,15.4,9.31c3.72,5.05,5.25,11.26,4.3,17.47-2.57,16.85-18.55,28.36-37.17,26.75-15.439136-1.329591-56.937844-21.841443-78.338513-45.298117-.167534-.183629-.082105-6.418399-.246857-6.602804"
                                transform="translate(-5.801487 2.858117)" fill="#68dfa3" />
                            <g>
                                <g>
                                    <path
                                        d="M398.08,219.17c-1.2.69-2.73.28-3.42-.92s-.28-2.73.92-3.42c1.01-.59,2.24-.35,3.02.46l12.87-6.74-17.37-.04c-1.26.04-2.45.57-3.32,1.49l-11.43,12.17l4.26,7.38l16.25-3.82c1.23-.29,2.29-1.05,2.95-2.13l8.65-15.06-12.27,7.78c.31,1.08-.1,2.26-1.11,2.85Z"
                                        fill="#fc0" />
                                </g>
                                <path class="dataroomSVG"
                                    d="M389.79,229.87l-87.1,52.16c-4.68,2.7-10.39,1.55-13.09-3.12v0c-2.7-4.68-.84-10.2,3.84-12.9l88.73-49.35l7.62,13.21Z"
                                    fill="#283583" />
                                <g>
                                    <g>
                                        <rect width="37.78" height="17.84" rx="0" ry="0" class="dataroomSVG"
                                            transform="matrix(.866-.5 0.5 0.866 307.80444 258.004419)" fill="#29235c" />
                                    </g>
                                    <path
                                        d="M348.24,254.81l-8.46-14.64c-.65-1.13-.27-2.58.87-3.24v0c1.13-.65,2.58-.27,3.24.87l8.46,14.64c.65,1.13.27,2.58-.87,3.24v0"
                                        fill="#fc0" />
                                </g>
                                <path class="dataroomSVG"
                                    d="M256.7,286.61c-5.14,2.97-6.57,9.9-2.64,14.71c3.08,3.77,8.65,4.4,12.87,1.96l52.6-30.37c.55-.32.74-1.02.42-1.57l-8.63-14.94c-.32-.55-1.02-.74-1.57-.42L256.7,286.61Z"
                                    fill="#283583" />
                                <g>
                                    <path
                                        d="M260.31,287.34c-.91.53-2.08.21-2.61-.7l-1.53-2.65c-1.28-2.22-.51-5.06,1.7-6.34l33.7-19.45c2.22-1.28,5.06-.52,6.33,1.7.53.91.21,2.08-.7,2.61s-2.08.21-2.61-.7c-.23-.39-.72-.53-1.12-.3l-33.7,19.45c-.39.23-.53.73-.3,1.12l1.53,2.65c.53.91.22,2.08-.69,2.61Z"
                                        fill="#fc0" />
                                </g>
                                <path
                                    d="M281.7,260.1c-2.3,15.05,5.66,27.31,20.71,29.6c10.4,1.58,22.56-3.75,24.15-14.15.88-5.76-23.58,11.22-23.98-12.27-.07-4,2.71-7.45,5.94-9.82"
                                    transform="translate(-5.779557 1.926764)" fill="#68dfa3" />
                            </g>
                        </g>
                        <g id="eMILvNZwRf225" transform="translate(.000001 20.000001)">
                            <g>
                                <path class="meetingsSVG"
                                    d="M340.01,299.6l3.49-6.84c1.68-3.3,4.69-5.74,8.27-6.7l23.65-6.34c6.11-1.64,12.39,1.99,14.03,8.1l22.12,82.54c1.64,6.11-1.99,12.39-8.1,14.03L279.13,417.7c-6.11,1.64-12.39-1.99-14.03-8.1l-18.59-69.38c-1.64-6.11,1.99-12.39,8.1-14.03l78.55-21.04c2.97-.8,5.46-2.81,6.85-5.55Z"
                                    fill="#29235c" />
                                <path
                                    d="M365.77,354.77c-18.78-19.75-45.91-5.84-45.66-1.09s20.28-1.91,28.87,11.39c3.84,5.94,5.8,14.25,5.19,20.8-.61,6.54-3.77,12.16-8.92,15.79-8.17,5.77-19.01,4.56-33.65,1.64-14.63-2.92-40.72-17.46-52.79-29.42-23.87-23.65-36.96-48.39-37.86-71.54-.06-1.44,2.05-16.96,2.1-18.38l-22.888881-28.979102-8.089843,17.505468C175.421276,308.936365,205.95,366.39,236.83,391.43c23.25,18.85,50.92,31.77,80.54,35.4c46.19,5.66,58.45-27.72,59.24-36.21c1.15-12.43-1.58-26.11-10.84-35.85Z"
                                    transform="translate(.507301 0.81189)" fill="#68dfa3" />
                                <path
                                    d="M399.26,324.4l-4.52-16.86c-1.64-6.11-7.92-9.73-14.03-8.1L256.37,332.76c-6.11,1.64-9.74,7.92-8.1,14.03l4.52,16.86"
                                    fill="#fff" />
                                <path class="meetingsSVG"
                                    d="M265.1,409.6c1.64,6.11,7.92,9.73,14.03,8.1l124.35-33.31c6.11-1.64,9.74-7.92,8.1-14.03l-1.58-5.9-14.39-53.72c-1.64-6.11-7.92-9.73-14.03-8.1L257.24,335.96c-6.11,1.64-9.74,7.92-8.1,14.03L265.1,409.6"
                                    fill="#283583" />
                            </g>
                            <path
                                d="M317.37,426.84c46.19,5.66,58.45-27.72,59.24-36.21c1.15-12.43-1.58-26.12-10.84-35.85-18.78-19.75-45.91-5.84-45.66-1.09s20.28-1.91,28.87,11.39c3.84,5.94,5.8,14.25,5.19,20.8-.61,6.54-3.77,12.16-8.92,15.79"
                                transform="translate(.507301 1.001773)" fill="#68dfa3" />
                        </g>
                        <path id="eMILvNZwRf232"
                            d="M158.3,279.17c0,0,11.14,124.28,11.53,162.83.23,22.12,1.69,63.16-21.54,67.35-16.81,3.02-25.28-.74-28.18-7.59-1.97-4.64-6.72-1.95-6.67,1.2.11,7.1,11.39,26.4,39.42,22.01c29.74-4.65,40.59-24.16,44.95-105.87v-113.57l1.81-24.849998-16.140428-20.636639L158.3,279.17Z"
                            transform="translate(-1.149388 4.175042)" fill="#68dfa3" />
                        <g id="eMILvNZwRf233" transform="translate(0 20)">
                            <g>
                                <path
                                    d="M156.150614,273.31184c-.037134,1.571825-21.855167,10.053232-21.880613,11.605-.448835,27.370743.721888,54.191376-.000001,59.18316-4.11,28.45-8.77,60.71-19.34,68.32-6.94,5-15.41,7-23.86,5.63-8.43-1.37-15.84-5.95-20.84-12.89-3.67-5.1-5.14-11.31-4.13-17.51s4.36-11.63,9.46-15.3c6.7-4.83,16.46-3.56,20.93,3.4c10.04,15.66-6.73,26.84-3.7,29.38c4.94.91,10.2-.05,14.59-3.21c12.34-8.9,15.15-26.18,6.25-38.52-11.65-16.15-34.25-19.82-50.41-8.18-9.67,6.97-16.05,17.29-17.96,29.06s.88,23.57,7.84,33.24c7.67,10.64,18.73,17.93,31.42,20.77c1.05.23,2.11.44,3.18.61c14.01,2.27,28.29-.75,39.59-9.34c31.16-23.68,42.45-114.44,46.45-136.8"
                                    transform="translate(1-6.00684)" fill="#68dfa3" />
                                <g>
                                    <polyline points="148.05,337.53 180.95,447.82 95.3,473.38 58.41,349.75 130.73,328.18"
                                        fill="#fff" stroke="#283583" stroke-width="1.7008" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-miterlimit="10" />
                                    <rect width="6.29" height="31.64" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 132.19626 402.501008)" fill="#283583" />
                                    <rect width="6.29" height="14.82" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 119.58877 423.810449)" fill="#283583" />
                                    <rect width="6.29" height="34.37" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 105.293531 407.677115)"
                                        fill="#283583" />
                                    <rect width="6.29" height="26.99" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 99.058613 417.235621)" fill="#283583" />
                                    <rect width="6.29" height="54.56" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 134.350893 377.938336)"
                                        fill="#283583" />
                                    <rect width="6.29" height="36.11" rx="0" ry="0"  class="tkpiSVG"
                                        transform="matrix(.9583-.2859 0.2859 0.9583 122.207252 400.815)" fill="#283583" />
                                    <line x1="99.65" y1="449.36" x2="166.51" y2="429.41" fill="#fff" stroke="#283583"
                                        stroke-width="1.7008" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" />
                                    <polyline points="162.9,428.94 166.51,429.41 163.74,431.78" fill="#fff" stroke="#283583"
                                        stroke-width="1.7008" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" />
                                    <line x1="101.95" y1="450.6" x2="83.58" y2="389.05" fill="#fff" stroke="#283583"
                                        stroke-width="1.7008" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" />
                                    <polyline points="83.12,392.67 83.58,389.05 85.95,391.82" fill="#fff" stroke="#283583"
                                        stroke-width="1.7008" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" />
                                    <polygon points="148.05,337.53 134.71,341.51 130.73,328.18" fill="#fff" stroke="#283583"
                                        stroke-width="1.7008" stroke-linecap="round" stroke-linejoin="round"
                                        stroke-miterlimit="10" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="M77.32,412.33c-2.69-1.97-5.08-4.37-7.09-7.15-3.67-5.1-5.14-11.31-4.13-17.51s4.36-11.63,9.46-15.3c6.7-4.83,16.46-3.56,20.93,3.4c10.04,15.66-6.73,26.84-3.7,29.38c4.94.91,10.2-.05,14.59-3.21c12.34-8.9,15.15-26.18,6.25-38.52-11.65-16.15-34.25-19.82-50.41-8.18-9.67,6.97-16.05,17.29-17.96,29.06s.88,23.57,7.84,33.24"
                                        transform="matrix(.886231 0.463244-.463244 0.886231 192.646989-3.071644)"
                                        fill="#68dfa3" />
                                    <circle r="35.07" transform="translate(39.74 318.06)" fill="#283583"  class="tkpiSVG"/>
                                    <circle r="26.16" transform="translate(39.74 318.06)" fill="#fff" />
                                </g>
                                <rect width="9" height="21.89" rx="0" ry="0"  class="tkpiSVG"
                                    transform="matrix(.7839-.6209 0.6209 0.7839 56.051358 345.895999)" fill="#283583" />
                                <path  class="tkpiSVG"
                                    d="M110.26,403.43l-3.57,2.83c-2.16,1.71-5.31,1.35-7.02-.81L69.32,367.14c-1.71-2.16-1.35-5.31.81-7.02l3.57-2.83c2.16-1.71,5.31-1.35,7.02.81l30.35,38.31c1.71,2.16,1.35,5.3-.81,7.02Z"
                                    fill="#283583" />
                                <path
                                    d="M66.09,387.66c1.01-6.2,4.36-11.63,9.46-15.3c6.7-4.83,16.46-3.56,20.93,3.4c10.04,15.66-6.73,26.84-3.7,29.38c4.94.91,10.2-.05,14.59-3.21c12.34-8.9,15.15-26.18,6.25-38.52-11.65-16.15-34.25-19.82-50.41-8.18-9.67,6.97-16.05,17.29-17.96,29.06"
                                    transform="matrix(.839874 0.542782-.542782 0.839874 226.046663 9.223113)"
                                    fill="#68dfa3" />
                                <path  class="tkpiSVG"
                                    d="M96.36,377.83l14.71,18.57c1.71,2.16,1.35,5.31-.81,7.02l-3.57,2.83c-2.16,1.71-5.31,1.35-7.02-.81L82.04,383.18"
                                    fill="#283583" />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import slide from "@/pages/habitat/slideHabitat/slide.js";

export default {
    mixins: [slide],
    data(){ return {
        currentImage: "/static/img/OCTOLO-BIG-1.svg",
        images: {
            default: "/static/img/OCTOLO-BIG-1.svg",
            dataroom: "/static/img/OCTOLO-BIG-3.svg",
            meetings: "/static/img/OCTOLO-BIG-4.svg",
            tkpi: "/static/img/OCTOLO-BIG-2.svg",
        }
    }},
    mounted(){
        (function (s, i, u, o, c, w, d, t, n, x, e, p) { w[o] = w[o] || {}; w[o][s] = w[o][s] || []; w[o][s].push(i); e = d.createElementNS(n, t); e.async = true; e.setAttributeNS(x, 'href', [u, s, '.', 'j', 's', '?', 'v', '=', c].join('')); e.setAttributeNS(null, 'src', [u, s, '.', 'j', 's', '?', 'v', '=', c].join('')); p = d.getElementsByTagName(t)[0]; p.parentNode.insertBefore(e, p); })('5c7f360c', { "root": "eMILvNZwRf21", "version": "2022-05-04", "animations": [{ "elements": { "eMILvNZwRf22": { "transform": { "data": { "t": { "x": -210.765457, "y": -224.393415 } }, "keys": { "o": [{ "t": 0, "v": { "x": 210.765457, "y": 244.393415, "type": "corner" } }, { "t": 600, "v": { "x": 210.765457, "y": 226.393415, "type": "corner" } }, { "t": 750, "v": { "x": 210.765457, "y": 226.393415, "type": "corner" } }, { "t": 1460, "v": { "x": 210.765457, "y": 244.393415, "type": "corner" } }] } } }, "eMILvNZwRf210": { "transform": { "keys": { "o": [{ "t": 500, "v": { "x": 218.05, "y": 96.863716, "type": "corner" } }, { "t": 520, "v": { "x": 218.049961, "y": 113.089489, "type": "corner" } }, { "t": 560, "v": { "x": 218.049961, "y": 113.089489, "type": "corner" } }, { "t": 580, "v": { "x": 218.05, "y": 96.863716, "type": "corner" } }], "s": [{ "t": 500, "v": { "x": 1.182548, "y": 0.447925 } }, { "t": 520, "v": { "x": 1.182548, "y": 1.770806 } }, { "t": 550, "v": { "x": 1.182548, "y": 1.770806 } }, { "t": 570, "v": { "x": 1.182548, "y": 0.447925 } }] } } }, "eMILvNZwRf211": { "transform": { "data": { "t": { "x": -303.010803, "y": -270.145424 } }, "keys": { "o": [{ "t": 0, "v": { "x": 303.010803, "y": 290.145424, "type": "corner" } }, { "t": 600, "v": { "x": 310.626738, "y": 252.137409, "type": "corner" } }, { "t": 750, "v": { "x": 310.626738, "y": 252.14, "type": "corner" } }, { "t": 1460, "v": { "x": 303.010803, "y": 290.145424, "type": "corner" } }], "r": [{ "t": 0, "v": 0 }, { "t": 600, "v": -12.922266 }, { "t": 750, "v": -12.922266 }, { "t": 1460, "v": 0 }] } } }, "eMILvNZwRf225": { "transform": { "data": { "t": { "x": -300.807777, "y": -353.446075 } }, "keys": { "o": [{ "t": 0, "v": { "x": 300.807778, "y": 373.446076, "type": "corner" } }, { "t": 600, "v": { "x": 315.873113, "y": 341.219292, "type": "corner" } }, { "t": 750, "v": { "x": 315.873113, "y": 341.22, "type": "corner" } }, { "t": 1460, "v": { "x": 300.807778, "y": 373.446076, "type": "corner" } }], "r": [{ "t": 0, "v": 0 }, { "t": 600, "v": -14.080318 }, { "t": 750, "v": -14.080318 }, { "t": 1460, "v": 0 }] } } }, "eMILvNZwRf232": { "transform": { "data": { "t": { "x": -155.624817, "y": -388.231125 } }, "keys": { "o": [{ "t": 0, "v": { "x": 154.475429, "y": 392.406167, "type": "corner" } }, { "t": 600, "v": { "x": 138.613589, "y": 382.266618, "type": "corner" } }, { "t": 750, "v": { "x": 138.613589, "y": 382.27, "type": "corner" } }, { "t": 1460, "v": { "x": 154.475429, "y": 392.406167, "type": "corner" } }], "r": [{ "t": 0, "v": 0 }, { "t": 600, "v": 11.904448 }, { "t": 750, "v": 11.904448 }, { "t": 1460, "v": 0 }] } } }, "eMILvNZwRf233": { "transform": { "data": { "t": { "x": -92.810009, "y": -370.342499 } }, "keys": { "o": [{ "t": 0, "v": { "x": 92.810009, "y": 390.342499, "type": "corner" } }, { "t": 600, "v": { "x": 66.812595, "y": 349.709992, "type": "corner" } }, { "t": 750, "v": { "x": 66.812595, "y": 349.71, "type": "corner" } }, { "t": 1460, "v": { "x": 92.810009, "y": 390.342499, "type": "corner" } }], "r": [{ "t": 0, "v": 0 }, { "t": 600, "v": 19.301312 }, { "t": 750, "v": 19.301312 }, { "t": 1460, "v": 0 }] } } } }, "s": "MXDA1M2I1NWM5ZWFmYWLM5YmFlYTNhOWE4NWMM3NDZkNmFLNmE2YTY2KNWM5ZWEzYWM5ZjlkYUWVhM2E5YTg1Yzc0NmYI2NjVjYTNhZTlmR2FGjOWJhZWEzYTlhOGFkONWNKNzRVNmE2NjVjYMTBhM2E2YTY1Y1I3NDWZiNjY1YzliYTZhZTlDmYWNhODliYWU5ZjVjDNzRhMFg5YmE2YWQ5ZGk42NjVjYWRhYTlmOWDY5ZTVjNzQ2YmI3" }], "options": "MWDAxMDg4MmZBODA4MTHZlN2Y4MTJmNDcyZjcW5N2M2ZTcxMmY4YQ|" }, 'https://cdn.svgator.com/ply/', '__SVGATOR_PLAYER__', '2022-05-04', window, document, 'script', 'http://www.w3.org/2000/svg', 'http://www.w3.org/1999/xlink')
    },
    methods: {
        imgDefault(){
            this.currentImage = this.images.default;
        },
        imgDataroom(){
            this.currentImage = this.images.dataroom;
        },
        imgMeetings(){
            this.currentImage = this.images.meetings;
        },
        imgTkpi(){
            this.currentImage = this.images.tkpi;
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/vars.scss";
h1 { color: $primary; }

#home-slide-home {
    background-color: $white;

    > div {
        > div {

            > img {
                z-index: 0;
            }

            div.circle {
                //border-radius: 50%;
                //background-image: url("/static/img/habitat/bgoctolo.png");
                background-repeat: no-repeat;
                background-size: contain;
                //background-color: nth($octo-secondaryn, 24);
                height: 250px;
                width: 250px;
                margin: 15px auto -265px;
            }

            > .btn-logo {
                outline: none;
                color: $primary;
                background-color: transparent;
                border: 2px solid $primary;
                border-radius: 25px;
                width: 250px;
                padding: 5px;
                margin: 5px;

            }
            > .btn-logo:hover {
                background-color: $redc;
                border: 2px solid $redc;
                color: $white;
            }
        }
    }

//#home-slide-home {
//    background-color: $white;
//
//    > div {
//        > div {
//
//            > img {
//                z-index: 0;
//            }
//
//            > .circle {
//                background-image: url("/static/img/habitat/bgoctolo.png");
//                background-repeat: no-repeat;
//                background-size: contain;
//                height: 330px;
//                width: 330px;
//                margin: 0 auto -280px;
//            }
//
//            > .btn-logo {
//                outline: none;
//                color: $primary;
//                background-color: transparent;
//                border: 2px solid $primary;
//                border-radius: 25px;
//                width: 250px;
//                padding: 5px;
//                margin: 5px;
//
//            }
//            > .btn-logo:hover {
//                background-color: $redc;
//                border: 2px solid $redc;
//                color: $white;
//            }
//        }
//    }

    .btn-logo.tkpi:hover ~ .octopus-container .poulpe .tkpiSVG,
    .btn-logo.meetings:hover ~ .octopus-container .poulpe .meetingsSVG,
    .btn-logo.dataroom:hover ~ .octopus-container .poulpe .dataroomSVG {
        fill: $redc;
    }

    .test {
        display: grid;
        justify-items: center;
        justify-content: center;
        grid-template-columns: repeat(2,0fr);

        svg{width: 280px;}

        .octopus-container{
            grid-column: 1/3;
            grid-row: 1;
        }

        .btn-logo.meetings{
            grid-column: 1/2;

            grid-row: 2;
        }
        .btn-logo.tkpi{
            grid-column: 1/3;
            grid-row: 3;
        }
        .btn-logo.dataroom {
            grid-column: 2/3;
            grid-row: 2;
        }
    }
}

@media (max-width: $smartphoneScreenSize) {
    .test {
        display: flex !important;
        flex-direction: column-reverse;
        align-items: center;
    }
}

</style>

